module.exports = "//static.hsappstatic.net/pricing-pages-ui/static-1.22147/js/img/productIcons/CMSHub_Pro.svg"